import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import '../App.css';
import GeoGebra from 'react-geogebra';
import useAuth from '../hooks/useAuth';
// import axiosimage from '../api/axiosimage';
import useAxiosImagePrivate from '../hooks/useAxiosImagePrivate';

const TodayProblemMyDesign = ()=> {
    const {proIDMy}=useParams();
    const {auth} = useAuth();
    const navigateto = useNavigate();
    const {todayProblemList, todayProblem, useStat, myAnswerList, problem, myAnswerRaw, isFirst, isLast, prevProblem, nextProblem, proID} = useLocation().state;
    const [randomString, setRandomString] = useState();
    const [designData, setDesignData] = useState([]);
    const [title, setTitle] = useState('');
    const [backColor, setBackColor] = useState('WHITE');
    const [defaultBackColor, setDefaultBackColor] = useState('WHITE');
    const [bcolor,setBcolor] = useState('');
    const [flag, setFlag] = useState('');
    const formData = new FormData();
    const axiosImagePrivate = useAxiosImagePrivate();
    const location = useLocation();

    useEffect(() => {
        const design = myAnswerRaw.designData.split("|");
        setDesignData(design);
    },[myAnswerRaw.designData])

    useEffect(() => {
        const revivalData = () => {
            const letters = '1234567890abcdefghijklmnopqrstuvwxyz';
            let randomStringl = '';
            for (let i = 0; i < 5; i++) {
                randomStringl += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString(randomStringl); 
        };
        revivalData();
    },[proIDMy])

    const onTitleHandler = (e) => {
        setTitle(e.target.value);
    }

    const onBackgroundColorHandler = () => {
        const app=window.ggbApplet;
        bcolor !== "" ? setBackColor(bcolor.toUpperCase()) : setBackColor('WHITE');
        app.evalCommand(`SetBackgroundColor(${backColor})`);
    }

    const saveMyCanvas = async () => {
        let isMounted = true;
        const controller = new AbortController();

        try {
            const response = await axiosImagePrivate.post('/canvas/create/', formData, {
                signal: controller.signal
            });
            isMounted && response.data && setFlag(true);
            alert("이 그림을 저장했습니다.");
        } catch (err) {
            // console.log(err);
            setFlag(false);
            if (err?.response?.status === 500) {
                alert("시간 초과로 로그아웃 되었습니다. 로그인 후 다시 시도해 주세요.");
                navigateto('/login', { state: { from: location }, replace: true });
            } else {
                alert("그림을 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.");
            }
        }

        // axiosImagePrivate.post('/coloring/my/history/add/', formData)
        // .then (response => {
        //     prevTime = new Date();
        //     alert("이 그림을 저장했습니다.");
        // }) 
        // .catch(err => {
        //     console.log(err);
        //     alert("이 그림을 저장하지 못했습니다. 잠시 후 다시 시도하세요.");
        // })

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    let prevTime=new Date();

    const onClickHandler = () => {
        const app=window.ggbApplet;
        let date = new Date();
        let elapsedTime = date - prevTime;
        let strUserid = auth?.accessToken? randomString : "visit";
        if (elapsedTime > 30000 && strUserid !== "visit") {
            let viewDate = date.toLocaleString('en-GB');
            let canvasCode = "qd"+viewDate.substring(0,2)+viewDate.substring(3,5)+viewDate.substring(6,10)+viewDate.substring(12,14)+viewDate.substring(15,17)+viewDate.substring(18,20)+strUserid;
            let canvasTitle = title || problem.problemTitle + "에 그린 그림";
            let canvasDescription = myAnswerRaw.solvingTime.substring(6,10) + "년 " + myAnswerRaw.solvingTime.substring(3,5) + "월 " + myAnswerRaw.solvingTime.substring(0,2) + "일 " + myAnswerRaw.solvingTime.substring(12,17) + "의 풀이를 이용한 그림";
            let canvasKeyword = "#그림"
            let orderNum = viewDate.substring(6,10)+viewDate.substring(3,5)+viewDate.substring(0,2)+viewDate.substring(12,14)+viewDate.substring(15,17)+viewDate.substring(18,20)
            let answerMark = canvasCode.substring(0,9)+viewDate.substring(0,2)+viewDate.substring(3,5)+viewDate.substring(6,10)+viewDate.substring(12,14)+viewDate.substring(15,17)+viewDate.substring(18,20);
            let myGGB = app.getBase64();
            let image = app.getPNGBase64(1,true,72);
            formData.append('canvasCode', canvasCode);
            formData.append('canvasTitle', canvasTitle);
            formData.append('canvasDescription', canvasDescription);
            formData.append('canvasKeyword', canvasKeyword);
            formData.append('customToolBar', "0 | 40 | 41 | 42");
            formData.append('showToolBarHelp', true);
            formData.append('enableLabelDrags', false);
            formData.append('enableShiftDragZoom', false);
            formData.append('allowStyleBar', true);
            formData.append('canvasType', 2);
            formData.append('canvasAdmin', 1);
            formData.append('language', "ko");
            formData.append('canvasCategoryCode', "user003");
            formData.append('orderNum', parseInt(orderNum));
            formData.append('image_data', image);
            formData.append('problemCode', problem.problemCode);
            formData.append('coloringTime', viewDate);
            formData.append('answerMark', answerMark);
            formData.append('backgroundColor', backColor);
            formData.append('basicSketch', myGGB);
            saveMyCanvas();
            if (flag) prevTime = new Date();
            // auth?.accessToken && axiosimage.post('/canvas/create/', formData, {
            //     headers: {
            //         'Authorization': `Bearer ${auth?.accessToken}`
            //     }
            // })
            //     .then (response => {
            //         prevTime = new Date();
            //         alert("이 그림을 저장했습니다.");
            //     })
            //     .catch(err => {
            //         alert("이 그림을 저장하지 못했습니다. 잠시 후 다시 시도하세요.")
            //     })
            // prevTime = new Date();
            // alert("이 그림을 저장했습니다.")
        } else alert("30초 이상 경과해야 그림을 저장할 수 있습니다.")
    }

    const onLoad = () => {
        const app = window.ggbApplet;
        // let obj_no = app.getObjectNumber();
        // let strName = '';
        app.evalCommand(`SetBackgroundColor(${defaultBackColor})`);

        for (let j=0; j < designData.length-1; j++) {
            let dataSolvingContent = designData[j];
            app.evalCommand(dataSolvingContent);
        } 
    }

    return(
        <div className="problem" key={myAnswerRaw.answerMark}>
            <div className="content-fit">

                <h5>{myAnswerRaw.solvingTime.substring(6,10)}년 {myAnswerRaw.solvingTime.substring(3,5)}월 {myAnswerRaw.solvingTime.substring(0,2)}일 {myAnswerRaw.solvingTime.substring(12,17)}의 풀이</h5>

                <div>
                    <input 
                        type="text" 
                        style={{width:"90%", height:"38px", marginBottom:"9px"}}
                        placeholder="그림의 제목을 입력하세요."
                        value={title} 
                        onChange={onTitleHandler} 
                        required 
                    />
                </div>

                <div>
                    <input 
                        type="text" 
                        id="color"
                        style={{width:"320px", height:"38px", marginBottom:"9px"}}
                        placeholder="SpringGreen처럼 영문으로 배경색을 입력"
                        onChange={(event) => setBcolor(event.target.value)} 
                    />
                    <button 
                        className='button'
                        style={{marginLeft:"9px", marginTop: "0px", marginRight:"9px"}}
                        onClick={onBackgroundColorHandler}
                    >
                        배경색 변경
                    </button>
                    (2번 클릭하면 변경됩니다. <a href="https://www.w3schools.com/tags/ref_colornames.asp" target='blank'>색 참조</a>)
                </div>

                {designData.length !== 0
                    ?   <GeoGebra
                            id="ggbApplet"
                            width={1100}
                            height={720}
                            // autoHeight={true}
                            appletOnLoad={onLoad}
                            showMenuBar={false}
                            showAlgebraInput={false}
                            showToolBar={true}
                            customToolBar={"0 | 62 | 1 67 5 19 | 2 15 18 7 | 4 3 8 9 13 44 | 16 51 | 10 53 11 24 20 22 21 23 | 55 56 57 12 | 30 29 54 32 31 33 | 36 38 49 | 17 | 40 | 41 | 42 | 27 | 6"}
                            showToolBarHelp={true}
                            showResetIcon={false}
                            enableLabelDrags={false}
                            enableShiftDragZoom={false}
                            enableRightClick={true}
                            errorDialogsActive={false}
                            useBrowserForJS={false}
                            allowStyleBar={true}
                            preventFocus={false}
                            showZoomButtons={false}
                            capturingThreshold={3}
                            rounding="8"
                            // add code here to run when the applet starts
                            showFullscreenButton={true}
                            scale={1}
                            disableAutoScale={false}
                            allowUpscale={false}
                            clickToLoad={false}
                            appName="classic"
                            buttonRounding={0.7}
                            buttonShadows={false}
                            language="ko"
                            ggbBase64={"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"}
                        />
                    :   "Loading"
                }
                <div className='horizontal-flex-container'>
                    <button 
                        className='button'
                        onClick={() => navigateto(`/todayproblem/my/${proIDMy}`, {state:{
                            "todayProblemList": todayProblemList,
                            "problem": problem,
                            "todayProblem": todayProblem,
                            "useStat": useStat,
                            "myAnswerList": myAnswerList,
                            "isFirst": isFirst,
                            "isLast": isLast,
                            "prevProblem": prevProblem,
                            "nextProblem": nextProblem,
                            "proID": proID
                        }})}
                    >
                        풀이로 돌아가기
                    </button>
                    <button 
                        className='button'
                        onClick={onClickHandler}
                    >
                        그림 보관하기
                    </button>
                </div>
            </div>
            <br/>
        </div>
    );
};

export default TodayProblemMyDesign;